import axios, { AxiosError } from "axios";

interface ErrorObject {
  message: string;
  error: any | null;
}

interface AddressData {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

export default async (postalCode: string): Promise<[ErrorObject | null, AddressData | null]> => {
  try {
    const formattedPostalCode = postalCode.replace(/[.-]/g, "");
    const url = `${process.env.REACT_APP_API_BASE_URL}/getPostalCode`;
    const { data } = await axios.post<AddressData>(url, {
      postalCode: formattedPostalCode,
    });

    if (Boolean(data)) {
      return [null, data];
    } else {
      return [{ message: "No data returned", error: null }, null];
    }
  } catch (error) {
    return [{ message: "Error on fetching postal code info", error }, null];
  }
};
